import { render, staticRenderFns } from "./faqEc.vue?vue&type=template&id=641163be&"
import script from "./faqEc.vue?vue&type=script&lang=js&"
export * from "./faqEc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports